import * as React from "react";
import Spacer from "../../../../../elements/Spacer";
import InformationCard from "../../../../../elements/InformationCard";
import SectionName from "../../../../../elements/SectionName";
import KeywordsHeader from "../../../../../components/model/ArticleKeywords/KeywordsHeader";
import KeywordsList from "../../../../../components/model/ArticleKeywords/KeywordsList";
import KeywordOccurrence from "../../../../../components/model/ArticleKeywords/KeywordOccurrence";

interface IArticleKeywordsModelOutputState {
  result: any;
  errorMessage: string;
}

class ArticleKeywordsModelOutput extends React.Component<{}, IArticleKeywordsModelOutputState> {
  public constructor(props: {}) {
    super(props);

    this.state = {
        result: "",
        errorMessage: ""
    };
  }

  public processResponse = (response: any) => {
    let result: any = null;
    if (response && response.keywords) {
      const data = response.keywords;
      const resultArr = Object.keys(data).map((keyword: string) => {
        return  {
          keyword,
          data: data[keyword]
        };
      });
      if (resultArr.length) {
          result = resultArr;
      }
    }

    if (result) {
      this.setState({result});
    } else {
      this.setState({errorMessage: "Unable to get keywords."});
    }
  };

  public render() {
    return <React.Fragment>
          {
            this.state.result ? <div>
                <Spacer/>
                <SectionName>Keywords</SectionName>
                <InformationCard>
                    {
                      this.state.result.map((item: any) => {
                        return <div key={item.keyword}>
                          <KeywordsHeader>{item.keyword}</KeywordsHeader>
                          <KeywordsList>
                            {
                              item.data.map((k: any) => {
                                return <li key={k.keyword}><KeywordOccurrence>{k.keyword} - {k.occurence}</KeywordOccurrence></li>;
                              })
                            }
                          </KeywordsList>
                          <Spacer/>
                        </div>;
                      })
                    }
                </InformationCard>
              </div> : <></>
          }
          {
            this.state.errorMessage ? <InformationCard>{this.state.errorMessage}</InformationCard> : <></>
          }
      </React.Fragment>;
  }
}

export default ArticleKeywordsModelOutput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/output/ArticleKeywords/ArticleKeywordsModelOutput.tsx